
import MarketAnalysisService from "@/service//MarketAnalysisService";
import FormatterService from '@/service/FormatterService'
import { sortItems } from 'vuetify/es5/util/helpers'
import { backendExceptionHandler } from '@/mixins';
import TooltipPopupPerformance from "@/components/tooltips/TooltipPopupPerformance.vue";

export default {
    name: 'MarketAnalysisPerformance',
    mixins: [backendExceptionHandler],
    components: { TooltipPopupPerformance },

    data() {
        return {
            isInitializing: true,
            errorMessage: null,
            performance: [],
            headers: [
                { text: this.$t('component.portfolio.portfolioPerformance.headers.name'), value: 'title', width: '200px' },
                { text: this.$t('component.portfolio.portfolioPerformance.headers.1D'), value: 'day', width: '120px', align: 'right' },
                { text: this.$t('component.portfolio.portfolioPerformance.headers.1W'), value: 'week', class: 'hidden-xs-only', width: '120px', align: 'right' },
                { text: this.$t('component.portfolio.portfolioPerformance.headers.1M'), value: 'month', width: '120px', align: 'right' },
                { text: this.$t('component.portfolio.portfolioPerformance.headers.3M'), value: 'threeMonths', class: 'hidden-xs-only', width: '120px', align: 'right' },
                { text: this.$t('component.portfolio.portfolioPerformance.headers.6M'), value: 'sixMonths', width: '120px', align: 'right' },
                { text: this.$t('component.portfolio.portfolioPerformance.headers.YTD'), value: 'ytd', class: 'hidden-sm-and-down', width: '120px', align: 'right' },
                { text: this.$t('component.portfolio.portfolioPerformance.headers.1Y'), value: 'year', width: '120px', align: 'right' },
                { text: this.$t('component.portfolio.portfolioPerformance.headers.5Y'), value: 'fiveYears', class: 'hidden-sm-and-down', width: '120px', align: 'right' },
            ],
        }
    },

    computed: {
        numberOfColumns() {
            const numberOfHiddenColumnsSmSize = 2
            const numberOfHiddenColumnsXsSize = 2
            let numberOfColumnsWithScreenSize = this.headers.length

            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    numberOfColumnsWithScreenSize = this.headers.length - (numberOfHiddenColumnsSmSize + numberOfHiddenColumnsXsSize)
                    break
                case 'sm':
                    numberOfColumnsWithScreenSize = this.headers.length - numberOfHiddenColumnsSmSize
                    break
                default:
                    break
            }

            return numberOfColumnsWithScreenSize
        },
    },

    methods: {
        async fetchPerformance() {
            try {
                const res = await this.marketAnalysisService.getMarketPerformance()

                this.raw = res.map(perf => {
                    const prices = perf.prices || {}
                    const relPerf = Object.keys(prices).reduce((accu, key) => {
                        accu[key] = prices[key].performanceRel
                        return accu
                    }, {})

                    return { ...perf, ...relPerf }
                })

                this.performance = this.formatPerformance(this.raw)
            } catch (e) {
                this.handleBackendException(e, this.$t('component.portfolio.portfolioPerformance.loadError'))
            } finally {
                this.isInitializing = false
            }
        },

        formatPerformance(raw) {
            const formatter = new FormatterService()
            return raw.map(performance => {
                const copy = Object.assign({}, performance)
                this.headers.filter(header => header.value != 'title').forEach(header => {
                    if (copy[header.value] && !isNaN(performance[header.value])) {
                        copy[header.value] = formatter.percent(performance[header.value])
                    } else {
                        copy[header.value] = '-'
                    }
                })
                return copy
            })
        },

        customSort(_items, sortBy, sortDesc, locale, customSorters) {
            if (this.isInitializing) {
                return []
            }
            if (this.raw) {
                return this.formatPerformance(sortItems(this.raw, sortBy, sortDesc, locale, customSorters))
            }
            return this.performance
        },

        getColorClass(value) {
            if (value == '-' || value == '0') {
                return 'coloredChange coloredChange--neutral'
            } else if (value > '0') {
                return 'coloredChange coloredChange--positive'
            } else if (value < '0') {
                return 'coloredChange coloredChange--negative'
            }
        },

        openPopup(item, headerValue) {
            this.$root.$emit('request-open-performance-tooltip-popup', item, headerValue)
        },
    },

    created() {
        this.format = new FormatterService(),
        this.marketAnalysisService = new MarketAnalysisService(this.$axios);
        this.fetchPerformance()
    }
}
